const teamsPL = [
  {
    name: 'Los Angeles Lakers',
    image: 'Lakers.png',
    description:
      'Los Angeles Lakers, jedna z najbardziej ikonicznych drużyn NBA z bogatą historią sukcesów.',
    history: [
      { year: '1980', event: 'Zdobyli swoje 7. mistrzostwo NBA' },
      { year: '1984', event: 'Dotarli do finałów NBA' },
      { year: '2000', event: 'Rozpoczeli erę trzech mistrzostw z rzędu' },
      { year: '2010', event: 'Zdobyli swoje 16. mistrzostwo NBA' },
      { year: '2020', event: 'Zdobyli mistrzostwo NBA' },
    ],
  },
  {
    name: 'Chicago Bulls',
    image: 'Bulls.png',
    description:
      'Chicago Bulls, drużyna koszykarska Michaela Jordana i legenda koszykówki.',
    history: [
      { year: '1991', event: 'Zdobyli swoje pierwsze mistrzostwo NBA' },
      { year: '1993', event: 'Skonczyli pierwszy tzw. „three-peat”' },
      { year: '1996', event: 'Sezon 72 zwycięstw i tytuł mistrzowski' },
      { year: '1998', event: 'Skonczyli drugi tzw. „three-peat”' },
      { year: '2010', event: 'Dotarli do finałów Konferencji Wschodniej' },
    ],
  },
  {
    name: 'Toronto Raptors',
    image: 'Raptors.png',
    description:
      'Kanadyjska profesjonalna drużyna koszykarska, znana z mistrzostwa w 2019 roku.',
    history: [
      { year: '2000', event: 'Pierwszy udział w play-off' },
      { year: '2016', event: 'Finały Konferencji Wschodniej' },
      { year: '2018', event: 'Najlepszy wynik w Konferencji Wschodniej' },
      { year: '2019', event: 'Zdobyli swoje pierwsze mistrzostwo NBA' },
      { year: '2020', event: 'Dotarli do drugiej rundy play-off' },
    ],
  },
  {
    name: 'Denver Nuggets',
    image: 'Nuggets.png',
    description:
      'Nazwani na cześć Gorączki Złota w Kolorado, najlepiej znani dzięki Nikola Jokić.',
    history: [
      { year: '1976', event: 'Dołączyli do NBA z ABA' },
      {
        year: '1985',
        event: 'Dotarli po raz pierwszy do finałów Konferencji Zachodniej',
      },
      {
        year: '2009',
        event:
          'Awansowali do finałów Konferencji Zachodniej z Carmelo Anthonym',
      },
      {
        year: '2023',
        event:
          'Zdobyli swoje pierwsze mistrzostwo NBA pod przewodnictwem Nikoli Jokicia',
      },
    ],
  },
];

export default teamsPL;
